import { LitElement, html, css } from '@hh/global.js'

class HHRadioWrapper extends LitElement {
  static properties = {
    disabled: {
      type: Boolean,
      reflect: true,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  firstUpdated() {
    this.disabled = this.input.disabled
    this.checked = this.input.checked
  }

  get input() {
    const slot = this.shadowRoot?.querySelector(`slot[name='input']`)
    return slot?.assignedNodes()[0] ?? null
  }

  render() {
    return html`
      <slot name="input" part="input"></slot>
      <slot name="label" part="label"></slot>
    `
  }

  static styles = css`
    *,
    *::before,
    *::after {
      box-sizing: border-box;
    }

    :host {
      display: flex;
      align-items: center;
      gap: var(--hh-space-2xs);
    }

    ::slotted(input) {
      appearance: none;
      touch-action: none;
      margin: 0;
      position: relative;
      cursor: pointer;
    }

    ::slotted(input)::before {
      content: '';
      pointer-events: none;
      display: block;
      width: 5px;
      height: 5px;
      padding: 0 2px;
      border-radius: 50%;
      background-color: var(--hh-color-neutral-ada, #949494);
    }

    ::slotted(input:focus),
    ::slotted(input:checked)::before {
      background-color: var(--hh-color-ink, #000);
      border-radius: 50%;
    }

    ::slotted(input:disabled),
    :host([disabled]) ::slotted(label) {
      cursor: not-allowed;
      opacity: 0.5;
    }

    ::slotted(label) {
      cursor: pointer;
    }
  `
}

customElements.define('hh-radio-wrapper', HHRadioWrapper)
